// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"592cddd4","117":"f204971c","161":"68bbb574","209":"e84591e5","248":"16955e89","478":"92202bb9","671":"8beff2a0","922":"b33a7810","964":"59c70ae0"}[chunkId] + ".chunk.js";
};